// extracted by mini-css-extract-plugin
export default {"wrapper":"d2-z","play":"e2-z"};